module.exports = __webpack_public_path__ + "static/img/btn_list_cxlq.a0495d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn_list_cxlq.png
// module id = Q75b
// module chunks = 1